import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'seds-modal',
    templateUrl: './seds-modal.component.html',
    styleUrls: ['./seds-modal.component.scss'],
    standalone: false
})
export class SedsModalComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<SedsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  public close(result: any) {
    this.dialogRef.close(result);
  }

  public getData() {
    return this.data ? this.data : {};
  }
}
